import React from "react";
import { Box, Flex, Text, Divider } from "@chakra-ui/react";

const Row = ({ label, value }) => (
  <Flex width="100%" justifyContent="space-between" my="8px">
    <Text fontSize="13px" color="#666">
      {label}
    </Text>
    <Text fontSize="14px" fontWeight="semibold">
      {value}
    </Text>
  </Flex>
);

// Manual bank-transfer launch mode — replaces the Paystack checkout panel
// for estates whose paymentSettings.paymentMode is BANK_TRANSFER. Purely
// informational: there is no submit/buy action here. This page never marks
// anything as paid and never triggers a vend — the resident transfers the
// funds themselves, outside the app, then the Estate Admin confirms receipt
// and approves the top-up (and vend) from the admin Top Up page.
export const BankTransferDetails = ({ bankTransfer }) => {
  const { bankName, accountName, accountNumber, instructions } = bankTransfer || {};
  const hasDetails = bankName || accountName || accountNumber;

  return (
    <Box bg="#fff" border="1px solid #f2f2f2" borderRadius="12px" p="20px">
      <Text color="#10112B" fontWeight="semibold" mb="10px">
        Pay for water by bank transfer
      </Text>
      <Text fontSize="13px" color="gray.600" mb="15px">
        Transfer your desired water-purchase amount to your estate account
        below. After payment, notify your Estate Administrator. Your water
        token will be generated after your payment is confirmed.
      </Text>

      {hasDetails ? (
        <>
          <Divider />
          <Row label="Bank Name" value={bankName || "—"} />
          <Row label="Account Name" value={accountName || "—"} />
          <Row label="Account Number" value={accountNumber || "—"} />
          <Divider />
          {instructions && (
            <Text fontSize="13px" color="gray.600" mt="15px">
              {instructions}
            </Text>
          )}
        </>
      ) : (
        <Text fontSize="13px" color="red.500">
          Bank transfer details have not been configured for this estate yet.
          Please contact your estate administrator.
        </Text>
      )}
    </Box>
  );
};
